import ApisServiceApp from '@api/ApisServiceApp'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'
import type { AxiosRequestConfig } from 'axios'

// đơn mua
export function getListReportDetail(querySt?: string, axiosConfig?: AxiosRequestConfig) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/report/bao-cao-chi-tiet-don-hang', {
      ...axiosConfig,
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

/** GET — trả về file Excel (blob). Bộ lọc giống danh sách báo cáo chi tiết. */
export function exportBaoCaoChiTietDonHang(querySt?: string, axiosConfig?: AxiosRequestConfig) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/report/bao-cao-chi-tiet-don-hang-export', {
      ...axiosConfig,
      params: query || {},
      responseType: 'blob',
      timeout: 300000,
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

/** Danh sách báo cáo theo đơn — tham số giống báo cáo chi tiết (bộ lọc chung). */
export function getListReportOrder(querySt?: string, axiosConfig?: AxiosRequestConfig) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/report/bao-cao-don-hang', {
      ...axiosConfig,
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

/** GET — file Excel (blob). Bộ lọc giống danh sách báo cáo theo đơn. */
export function exportBaoCaoDonHang(querySt?: string, axiosConfig?: AxiosRequestConfig) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/report/bao-cao-don-hang-export', {
      ...axiosConfig,
      params: query || {},
      responseType: 'blob',
      timeout: 300000,
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
